import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ForgeRockTokenService {
  constructor(private _configService: ConfigService) {}

  public getAccessToken(): string {
    return this.getStorageToken('access_token', 'accessToken');
  }

  public getIdToken(): string {
    return this.getStorageToken('id_token', 'idToken');
  }

  private getStorageToken(snakeCaseKey: string, camelCaseKey: string): string {
    const auth = this._configService._config.forgeRockAuth;
    const clientId = auth.client_id || 'alianca001';
    const baseKey = `al.${auth.urlAuth}.${clientId}`;

    return localStorage.getItem(`${baseKey}.${snakeCaseKey}`)
      || localStorage.getItem(`${baseKey}.${camelCaseKey}`)
      || localStorage.getItem(`al.${auth.urlAuth}.alianca001.${snakeCaseKey}`)
      || localStorage.getItem(`al.${auth.urlAuth}.alianca001.${camelCaseKey}`);
  }

  public hasAccessToken(): boolean {
    return !!this.getAccessToken();
  }
}
